export const groupBy = (arr, keyFn) => {
  return arr.reduce((group, entry) => {
    const key = keyFn(entry);
    group[key] = group[key] ?? [];
    group[key].push(entry);
    return group;
  }, {});
};

export const unique = (arr) => {
  return [...new Set(arr)];
};

export const addOrRemove = (set, val) => {
  const newSet = new Set(set);
  if (newSet.has(val)) {
    newSet.delete(val);
  } else {
    newSet.add(val);
  }
  return newSet;
};

const joinWithConjunction = (conj) => (arr) => {
  if (arr.length === 1) {
    return arr[0];
  }

  let str = "";
  for (let i = 0; i < arr.length; i++) {
    str += arr[i];
    if (i < arr.length - 2) {
      str += ", ";
    } else if (i === arr.length - 2) {
      str += ` ${conj} `;
    }
  }
  return str;
};

export const stringSort = ({ data, valueFn, isIgnoreCase }) => {
  const sorted = data ? [...data] : data;
  sorted?.sort((a, b) => {
    const aVal = isIgnoreCase ? valueFn(a)?.toLowerCase() : valueFn(a);
    const bVal = isIgnoreCase ? valueFn(b)?.toLowerCase() : valueFn(b);
    return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
  });
  return sorted;
};

export const joinWithAnd = joinWithConjunction("and");
